/**
 * Service for geocoding addresses using Google Maps Geocoding API
 */

const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;

/**
 * Convert an address to coordinates (latitude, longitude)
 * @param {string} address - The address to geocode
 * @returns {Promise<{latitude: number, longitude: number}>} Coordinates object
 */
export const geocodeAddress = async (address) => {
    try {
        const encodedAddress = encodeURIComponent(address);
        const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodedAddress}&key=${GOOGLE_MAPS_API_KEY}`;

        console.log('Geocoding address:', address);

        const response = await fetch(url);
        const data = await response.json();

        if (data.status === 'OK' && data.results.length > 0) {
            const location = data.results[0].geometry.location;
            console.log('Geocoding successful:', location);

            return {
                latitude: location.lat,
                longitude: location.lng
            };
        } else {
            console.error('Geocoding failed:', data.status, data.error_message);
            throw new Error(`Geocoding failed: ${data.status}`);
        }
    } catch (error) {
        console.error('Error geocoding address:', error);
        throw error;
    }
};
